// removed by extract-text-webpack-plugin
module.exports = {"section":"c-OrderSection__section","borderBottom":"c-OrderSection__borderBottom","transparent":"c-OrderSection__transparent","content":"c-OrderSection__content"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/OrderSection/OrderSection.scss
// module id = 800
// module chunks = 0